import { type ButtonHTMLAttributes, type ReactNode } from 'react'
import clsx from 'clsx'

type Variant = 'primary' | 'danger' | 'success' | 'ghost' | 'wa' | 'dark'
type Size = 'sm' | 'md' | 'lg'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  variant?: Variant
  size?: Size
  loading?: boolean
}

const variantClass: Record<Variant, string> = {
  primary: 'bg-accent text-white hover:opacity-90',
  danger: 'bg-danger text-white hover:opacity-90',
  success: 'bg-success text-white hover:opacity-90',
  ghost: 'bg-transparent text-text-secondary border border-border hover:bg-card-hover',
  wa: 'bg-[#25D366] text-white hover:opacity-90',
  dark: 'bg-surface text-text-primary border border-border hover:bg-card-hover',
}

const sizeClass: Record<Size, string> = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base',
}

export function Btn({
  children, variant = 'primary', size = 'md', loading, disabled, className, ...rest
}: Props) {
  return (
    <button
      {...rest}
      disabled={disabled || loading}
      className={clsx(
        'inline-flex items-center justify-center gap-2 rounded-lg font-bold',
        'transition-opacity disabled:opacity-50 disabled:cursor-not-allowed',
        variantClass[variant],
        sizeClass[size],
        className
      )}
    >
      {loading ? <span className="animate-spin">⏳</span> : null}
      {children}
    </button>
  )
}
